import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Setup from './pages/Setup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Reports from './pages/Reports';
import AdminBusinesses from './pages/admin/Businesses';
import AdminBusinessDetail from './pages/admin/BusinessDetail';
import BusinessSetup from './pages/business/Setup';
import MyExpenses from './pages/expenses/MyExpenses';
import ExpenseSubmit from './pages/expenses/ExpenseSubmit';
import ExpenseDetail from './pages/expenses/ExpenseDetail';
import Approvals from './pages/expenses/Approvals';
import Finance from './pages/expenses/Finance';
import MyPurchaseRequests from './pages/purchase-requests/MyPurchaseRequests';
import PurchaseRequestSubmit from './pages/purchase-requests/PurchaseRequestSubmit';
import PurchaseRequestDetail from './pages/purchase-requests/PurchaseRequestDetail';
import PurchaseRequestApprovals from './pages/purchase-requests/PurchaseRequestApprovals';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/login" element={<Layout><Login /></Layout>} />
          <Route path="/setup" element={<Layout><Setup /></Layout>} />
          <Route path="/forgot-password" element={<Layout><ForgotPassword /></Layout>} />
          <Route path="/reset-password/:token" element={<Layout><ResetPassword /></Layout>} />

          {/* Profile (any authenticated user) */}
          <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />

          {/* Platform admin */}
          <Route path="/admin/businesses" element={
            <ProtectedRoute roles={['platform_admin']}><Layout><AdminBusinesses /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/businesses/:id" element={
            <ProtectedRoute roles={['platform_admin']}><Layout><AdminBusinessDetail /></Layout></ProtectedRoute>
          } />

          {/* Business setup (ceo or platform_admin) */}
          <Route path="/business/setup" element={
            <ProtectedRoute roles={['ceo', 'platform_admin']}><Layout><BusinessSetup /></Layout></ProtectedRoute>
          } />

          {/* Expenses */}
          <Route path="/expenses/mine" element={
            <ProtectedRoute roles={['employee', 'head_of_dept', 'director', 'ceo', 'finance']}><Layout><MyExpenses /></Layout></ProtectedRoute>
          } />
          <Route path="/expenses/new" element={
            <ProtectedRoute roles={['employee', 'head_of_dept', 'director', 'ceo', 'finance']}><Layout><ExpenseSubmit /></Layout></ProtectedRoute>
          } />
          <Route path="/expenses/:id" element={
            <ProtectedRoute><Layout><ExpenseDetail /></Layout></ProtectedRoute>
          } />
          <Route path="/approvals" element={
            <ProtectedRoute roles={['head_of_dept', 'director', 'ceo']}><Layout><Approvals /></Layout></ProtectedRoute>
          } />

          {/* Purchase Requests */}
          <Route path="/purchase-requests/mine" element={
            <ProtectedRoute roles={['employee', 'head_of_dept', 'director', 'ceo', 'finance']}><Layout><MyPurchaseRequests /></Layout></ProtectedRoute>
          } />
          <Route path="/purchase-requests/new" element={
            <ProtectedRoute roles={['employee', 'head_of_dept', 'director', 'ceo', 'finance']}><Layout><PurchaseRequestSubmit /></Layout></ProtectedRoute>
          } />
          <Route path="/purchase-requests/:id" element={
            <ProtectedRoute><Layout><PurchaseRequestDetail /></Layout></ProtectedRoute>
          } />
          <Route path="/purchase-request-approvals" element={
            <ProtectedRoute roles={['head_of_dept', 'director', 'ceo']}><Layout><PurchaseRequestApprovals /></Layout></ProtectedRoute>
          } />

          <Route path="/finance" element={
            <ProtectedRoute roles={['employee', 'head_of_dept', 'director', 'ceo', 'finance', 'platform_admin']}><Layout><Finance /></Layout></ProtectedRoute>
          } />

          {/* Reports */}
          <Route path="/reports" element={
            <ProtectedRoute roles={['ceo', 'finance', 'platform_admin']}><Layout><Reports /></Layout></ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
